<style scoped>
.link {
  width: 100%;
}
</style>
<template>
  <div>
    <ul>
      <li class="truncate" v-for="(item, index) in toc" v-bind:key="index">
        <a
          :href="`#${item.value}`"
          v-bind:class="{
            'pl-2 mb-1 font-medium text-gray-700': item.element == 'h2',
            'pl-6 text-sm text-gray-600 mb-1': item.element == 'h3',
            'text-blue-600 border-l-2 border-blue-500 font-medium':
              item.value == firstSelected,
          }"
        >
          {{ item.value }}
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'TableOfContents',
  props: {
    toc: Array,
  },
  data() {
    return {
      visible: {},
    };
  },
  computed: {
    firstSelected: function () {
      return Object.keys(this.visible).find((k) => this.visible[k] === true);
    },
  },
  mounted() {
    if (!IntersectionObserver) {
      // not supported on IE11
      return;
    }

    const handleObserver = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio > 0) {
          this.$set(this.visible, entry.target.getAttribute('id'), true);
        } else {
          this.$set(this.visible, entry.target.getAttribute('id'), false);
        }
      });
    };

    const observer = new IntersectionObserver(handleObserver);
    document.querySelectorAll('.anchor').forEach((section) => {
      this.$set(this.visible, section.getAttribute('id'), false);
      observer.observe(section);
    });

    this.observer = observer;
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
};
</script>
